import isEmpty from 'lodash/isEmpty';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { fetchLvmSales } from 'dashboard/actions/lvm-sales-history/lvm-sales-history.actions';
import template from './lvm-sales-widget.html';

const mapStateToThis = ({ session, lvmSalesHistory, dictionary }) => {
  const { total, isLoading } = lvmSalesHistory;
  const { locale, retailer } = session;
  const terms = dictionary.terms[locale];

  return {
    retailer,
    total,
    isLoading,
    locale,
    terms,
  };
};

const mapDispatchToThis = {
  fetchLvmSales,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state', 'gettextCatalog')
class LvmSalesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.activeTabIdx = 0;
    this.tabs = [];
    this.retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.isYear = false;
    this.$scope.$applyAsync(this.loadData.bind(this));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  async loadData() {
    await this.fetchLvmSales(this.retailerId);
    this.checkIfEmptyData();
    this.createTabs();
    this.onChangePeriodYear(this.isYear);
  }

  createTabs() {
    this.tabs = [
      this.generateTab(this.findDataItem('WTD'), 'WTD', this.gettextCatalog.getString('Week to date LVM sales')),
      this.generateTab(this.findDataItem('MTD'), 'MTD', this.gettextCatalog.getString('Month to date LVM sales')),
      this.generateTab(this.findDataItem('QTD'), 'QTD', this.gettextCatalog.getString('Quarter to date LVM sales')),
      this.generateTab(this.findDataItem('YTD'), 'YTD', this.gettextCatalog.getString('Year to date LVM sales')),
    ];
  }

  findDataItem(periodType) {
    return this.total ? this.total.find((item) => item.periodType === periodType) : null;
  }

  generateTab(dataItem, periodType, title) {
    return {
      title,
      tabTitle: periodType,
      total: dataItem ? dataItem.salesTotal : 0,
    };
  }

  checkIfEmptyData() {
    this.isEmpty = isEmpty(this.total);
  }

  onChangePeriodYear(isYear) {
    this.isYear = isYear;
    const item = this.findDataItem(this.tabs[this.activeTabIdx].tabTitle);
    if (!item) return;

    if (isYear) {
      this.salesDelta = item.salesDeltaYear;
      this.deltaAsPerc = item.deltaAsPercYear;
    } else {
      this.salesDelta = item.salesDeltaPeriod;
      this.deltaAsPerc = item.deltaAsPercPeriod;
    }
  }
}

export default class LvmSalesWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&',
    };
    this.template = template;
    this.controller = LvmSalesWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lvm-sales/components/lvm-sales-widget/lvm-sales-widget-component.js